import { createBrowserRouter } from 'react-router'

import { AppLayout } from '@/components/layout/AppLayout'
import { RouteErrorPage } from '@/pages/error/RouteErrorPage'
import { HomePage } from '@/pages/home/HomePage'
import { NotFoundPage } from '@/pages/not-found/NotFoundPage'

/**
 * Register new pages as children of the layout. Heavy pages should use `lazy` so they are
 * split into their own chunk:
 *   { path: 'wallet', lazy: async () => ({ Component: (await import('@/pages/wallet/WalletPage')).WalletPage }) }
 */
export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    errorElement: <RouteErrorPage />,
    children: [
      { index: true, element: <HomePage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
])
